import { ApoliceLogo } from '@/core/domain/porto-seguro/apolices/apolices.types';
import { applyCpfCnpjMask } from '@/utils/mask';
import { Skeleton, Card, Empty, Radio, Divider } from 'antd';
import moment from 'moment';
import Group from '../Group';
import { PortoPolicy } from '@/core/domain/porto/policies/porto-policies.types';

interface Props {
  policies?: PortoPolicy[];
  loading: boolean;
  licensePlate?: string;
  policyNumber?: string;
  onSelect(policy: PortoPolicy): void;
}

export default function PoliciesCardList({
  policies,
  loading,
  licensePlate,
  policyNumber,
  onSelect,
}: Props) {
  return (
    <Skeleton loading={loading}>
      <div className="workorder-polices">
        {!policies?.length && !licensePlate && (
          <Card style={{ borderRadius: 8 }}>
            <Empty description="Informe uma placa para listar as apolices" />
          </Card>
        )}

        {!policies?.length && licensePlate?.length === 7 && (
          <Card style={{ borderRadius: 8 }}>
            <Empty description="Não foi encontrado apolices para a placa informada" />
          </Card>
        )}

        {licensePlate?.length === 7 &&
          policies?.map((policy) => (
            <div
              className="workorder-policy-card"
              key={policy.policyNumber}
              data-active={policy.policyNumber === policyNumber}
              onClick={() => onSelect(policy)}
            >
              <Group gap={16} align="start">
                <Radio checked={policy.policyNumber === policyNumber} />
                <div className="policy-content">
                  <Group>
                    <img src={ApoliceLogo[policy.companyCode]} />
                    <Divider type="vertical" />
                    <span>
                      Vigència:{' '}
                      {moment(policy.finalValidityDate).format('DD/MM/YYYY')}
                    </span>
                  </Group>

                  <div>
                    <strong>{`${licensePlate} • ${policy.vehicle.brand} ${policy.vehicle.model}`}</strong>
                    <div>{policy.customer.name}</div>
                    <div>
                      {applyCpfCnpjMask(policy.customer.documentNumber)}
                    </div>
                  </div>
                </div>
              </Group>
            </div>
          ))}
      </div>
    </Skeleton>
  );
}
